<template>
  <div class="recommending">
    <!-- <div class="banner">
      <span>推荐单位</span>
    </div> -->
    <div class="content">
      <div class="main_title">
        双推双促首批拟邀请推荐单位名单(排名不分先后)
      </div>
      <div class="textContent">
        <div class="lineTop"></div>
        <div class="plr24">
          <img src="@/assets/topIcon.png" class="topIconImg" alt="">
        </div>
        <div  class="lineTop"></div>
      </div>
      <div class="listContent">
        <div class="listHeader">
        <div class="t1">序号</div>
        <div class="t2">推荐单位名称</div>
        <div class="t3">机构类别</div>
      </div>
      <div class="listHeader" v-for="(item,index) in recommendList">
        <div class="b1">{{index+1}}</div>
        <div class="b2">{{item.user_name}}</div>
        <div class="b3">{{item.org_category_name}}</div>
      </div>

      </div>


    </div>
  </div>
</template>

<script>

export default {
  name: "Recommending",
  data() {
    return {
      recommendList: [],
      count: 0,
        filters: {
          pageSize: 9999,
          currPage: 1
        }
    }
  },
  mounted() {
    this.getRecommendList()
  },
  methods: {
    getRecommendList() {
      this.$API.getRecommendList(this.filters).then(res => {
        // this.count = res.data.pageInfo.allRows;
        this.recommendList = res.data.list;
      })
    }
  }
}
</script>

<style scoped lang="less">

.b1{
  width: 16.6%;
  font-size: 18px;
  margin-left: 8.3%;
  color: #5c5c5c;
}
.b2{
  width: 40%;
  font-size: 18px;
  color: #5c5c5c;
  margin-left: 13%;
}
.b3{
  width: 16.6%;
  font-size: 18px;
  margin-left: 4.1%;
  color: #5c5c5c;
}
.t1{
  width: 16.6%;
  text-align: center;
  font-size: 32px;
  color: #5c5c5c;
}
.t2{
  width: 60%;
  text-align: center;
  font-size: 32px;
  color: #5c5c5c;
}
.t3{
  width: 16.6%;
  text-align: center;
  font-size: 32px;
  color: #5c5c5c;
}
.listHeader{
  display: flex;
  line-height: 38px;
}
.listContent{
  width: 1100px;
  margin: 0 auto
}
.lineTop{
  width: 50%;
  border-top: 1px solid #e8e8e8;
}
.plr24{
  padding: 0 24px;
}
.textContent{
  width: 1100px;
  margin: 20px 50px;
  display: flex;
  align-items: center;
}
.topIconImg{

}
.recommending {
  background: #f5f5f5;
}
.banner{
  position: relative;
    z-index: 2;
    overflow: hidden;
    background: #000;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    background-image: url('../../assets/tjdwBanner.png');
    background-repeat: no-repeat;
    background-position: 50%;
    width: 100%;
    min-height: 350px;
    -webkit-align-items: center;
    align-items: center;
    span{
      color: #fff;
    letter-spacing: 5px;
    font-size: 50px;
    text-align: center;
    }
}
.content{
  width: 1200px;
    margin: 0 auto;
    padding-top: 30px;
    padding-bottom: 30px;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-justify-content: center;
    justify-content: center;
    background-color: #fff;
}
.main_title{
  font-size: 32px;
    text-align: center;
    height: 40px;
    color: #5c5c5c;
}
</style>
